import { types } from "../action-types";

const initialState = {
    loading: false,
    success: false,
    error: false,
};

const createInterviewReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.CREATE_INTERVIEW_REQUESTED:
            return {
                ...state,
                success: false,
                loading: true,
            };

        case types.CREATE_INTERVIEW_SUCCESS:
            return {
                ...state,
                success: true,
                loading: false,
                error: false,
            };
        case types.CREATE_INTERVIEW_FAILURE:
            return {
                ...state,
                loading: false,
                success: false,
                error: true,
            };
        default:
            return state;
    }
};
export default createInterviewReducer;
